import { forwardRef, type InputHTMLAttributes } from 'react';
import { cn } from '@/lib/utils';

export function inputClassName(opts?: { leadingIcon?: boolean }, className?: string) {
  return cn('input', opts?.leadingIcon && 'input-leading-icon', className);
}

export type InputProps = InputHTMLAttributes<HTMLInputElement> & {
  leadingIcon?: boolean;
};

export const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ className, leadingIcon, ...props }, ref) => (
    <input ref={ref} className={inputClassName({ leadingIcon }, className)} {...props} />
  ),
);
Input.displayName = 'Input';
